import { render, staticRenderFns } from "./sms-input.vue?vue&type=template&id=1279befc&scoped=true&"
import script from "./sms-input.vue?vue&type=script&lang=js&"
export * from "./sms-input.vue?vue&type=script&lang=js&"
import style0 from "./sms-input.vue?vue&type=style&index=0&id=1279befc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1279befc",
  null
  
)

export default component.exports